module.exports = __webpack_public_path__ + "img/card-add-home.fdd352d1.png";